<svg [ngClass]="className">
  <use attr.xlink:href="{{ 'assets/sprites/svg/sprite.symbol.svg#' + icon }}"></use>
</svg>
